import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_BEGIN,
  DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_SUCCESS,
  DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_FAILURE,
  DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function createDeploymentSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_BEGIN,
    });
    const { projectId, body } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/deployment/setting`,
        body,
        header,
      );
      doRequest.then(
        (res) => {
          console.log('res.data', res.data);
          if (res.data) {
            if (res.data.success === false) {
              dispatch({
                type: DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_FAILURE,
                data: { error: res.data.message },
              });
              toast.error(`Error: ${res.data.message}`);
            } else {
              toast.success('File Upload Successfully !', {});
              dispatch({
                type: DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_SUCCESS,
                data: res.data,
              });
            }
          }
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_FAILURE,
            data: { error: 'Failed to create deplyment setting' },
          });
          toast.error(`Error: Failed to create deplyment setting`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateDeploymentSettingError() {
  return {
    type: DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_BEGIN:
      return {
        ...state,
        createDeploymentSettingPending: true,
        createDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_SUCCESS:
      return {
        ...state,
        createDeploymentSettingPending: false,
        createDeploymentSettingError: null,
      };

    case DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_FAILURE:
      return {
        ...state,
        createDeploymentSettingPending: false,
        createDeploymentSettingError: action.data.error,
      };

    case DEPLOYMENT_SETTING_CREATE_DEPLOYMENT_SETTING_DISMISS_ERROR:
      return {
        ...state,
        createDeploymentSettingError: null,
      };

    default:
      return state;
  }
}
